// Add modules here to include them in dist/vendor.js file for improved code splitting

// IMPORTANT: babel-polyfill must be imported, but only once, so leave it imported only in this file
// *********************
import 'babel-polyfill';
// *********************
import 'jquery';
import 'svgxuse';
import 'gsap/TweenMax.js';
import 'gsap/TweenLite';
import 'slick-carousel/slick/slick.js';
import 'ScrollMagic/scrollmagic/uncompressed/ScrollMagic.js';
import 'ScrollMagic/scrollmagic/uncompressed/plugins/animation.gsap.js';
import 'ScrollMagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js';
import 'vendor/chosen.jquery';
import 'jquery.nicescroll/jquery.nicescroll';
import 'video.js/dist/video.js';
import 'vendor/dropzone';
import 'rangeslider.js/dist/rangeslider.js';
import 'vendor/bootstrap-datepicker.min';
import 'vendor/platform.js';




//////////////////
// WEBPACK FOOTER
// ./static/js/vendor.js
// module id = 154
// module chunks = 1